import React, { useContext, useEffect, useState } from "react";
import { Colorcontext } from "../../../Component/Colorcontext/ColorContext";
import Blmpostadd from "../../SearchHome/Blmpostadd";
import Viewersengagement from "../../SearchHome/Viewersengagement";
import Upgradeprofile from "../../SearchHome/Upgradeprofile";
import Contactdetaiilsprofile from "../../SearchHome/Contactdetaiilsprofile";
import Socilallinkprofile from "../../SearchHome/Socilallinkprofile";
import Galleryblmprofile from "../../SearchHome/Galleryblmprofile";
import Searchkeywordprofile from "../../SearchHome/Searchkeywordprofile";
import { useLocation } from "react-router-dom";
import UploadBannerMyPage from "../../SearchHome/UploadBannerMyPage";
import HttpClient from "../../../utils/HttpClient";
import MyPageProfileUpdate from "../../SearchHome/MyPageProfileUpdate";
import MyPageAboutUs from "../../SearchHome/MyPageAboutUs";
import MyPageServices from "../../SearchHome/MyPageServices";

const ListBusinessMyPage = ({ formData, updateData, onNext, onBack }) => {
  const colordata = useContext(Colorcontext);
  const location = useLocation();
  const [isUpdate, setIsUpdate] = useState(false)
  const [data, setData] = useState(formData);

  useEffect(() => {
    colordata.setcolor(true);
    return () => {
      colordata.setcolor(false);
    };
  }, []);

  const updateForm = async (key, value) => {
    setData((prev) => ({ ...prev, [key]: value }));
    updateData(key, value);
  };

  useEffect(() => {
    if (data) {
      HttpClient.requestData("update-my-page", "POST", data);
    }
  }, [data]);

  return (
    <>
      <section className="wizrd-item-section ">
        <div className="wizrd-item-container">

          <div className=" reposivecideforspecial">
            <div className="ownblmprofiledivleft">
              <div className="repsonsivedivcls">
                {/* For Tablet responsive code start  */}
                <div className=" oenblmsnfidivmainleft">
                  <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                    <MyPageProfileUpdate updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />
                  </div>

                  <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                    <Contactdetaiilsprofile
                      setData={setData}
                      data={data}
                      updateForm={updateForm}
                      setIsUpdate={setIsUpdate}
                    />
                  </div>
                </div>

                <div className="oenblmsnfidivmainright">
                  <div className="oenblmsnfdrpbapbbtm responsivdedivmain ">
                    <Blmpostadd />
                  </div>
                  <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                    <Viewersengagement />
                  </div>
                  <div className="oenblmsnfdrpbapbbtm responsivdedivmain ">
                    <Upgradeprofile />
                  </div>
                  <div className="oenblmsnfdrpbapbbtm responsivdedivmain">
                    <UploadBannerMyPage data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
                  </div>
                </div>
                {/* For Tablet responsive code  end */}
              </div>

              <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                <MyPageProfileUpdate updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />
              </div>

              <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                <Blmpostadd />
              </div>

              <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                <Viewersengagement />
              </div>

              <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                <Upgradeprofile />
              </div>
              <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                <Contactdetaiilsprofile
                  setData={setData}
                  data={data}
                  updateForm={updateForm}
                  setIsUpdate={setIsUpdate}
                />
              </div>
            </div>
            <div className="ownblmprofiledivright">
              <div className="oenblmsnfdrpbapbbtm deslrtopwdijjsmain">
                <UploadBannerMyPage data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
              </div>
              <div className="oenblmsnfdrpbapbbtm">
                <MyPageAboutUs data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
              </div>

              <div className="oenblmsnfdrpbapbbtm">
                <MyPageServices data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
              </div>

              <div className="oenblmsnfdrpbapbbtm">
                <Searchkeywordprofile data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
              </div>

              <div className="oenblmsnfdrpbapbbtm">
                <Galleryblmprofile
                  setData={setData}
                  data={data}
                  updateForm={updateForm}
                  setIsUpdate={setIsUpdate}
                />
              </div>
              <div className="oenblmsnfdrpbapbbtm">
                <Socilallinkprofile updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />

                <div className="box-border-gr d-flex justify-content-center align-items-center bg-white p-3 mt-2">
                  <button className="btn btn-secondary mr-2" onClick={onBack}>
                    Back
                  </button>
                  <button className="btn btn-success" onClick={onNext}>
                    Pay Now
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile Screen Design Start */}

          <div className="mobilereposiveprofile">
            <div className="bannerprofileblmreposnive">
              <UploadBannerMyPage data={data} updateForm={updateForm} />
            </div>
            <div className="mobilereposvispsicaldivflx">
              <div className="eidteprofileblmreposnive">
                <MyPageProfileUpdate updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />
              </div>

              <div className="viewsprofileprofileblmreposnive">
                <div className="">
                  <Viewersengagement />
                </div>
                <div className="bklmlposprofileprofileblmreposnive">
                  <Blmpostadd />
                </div>

                <div className="">
                  <Upgradeprofile />
                </div>
              </div>
            </div>
            <div className="contaallprofileblmreposnive">
              <Contactdetaiilsprofile
                setData={setData}
                data={data}
                updateForm={updateForm}
                setIsUpdate={setIsUpdate}

              />
            </div>
            <div className="contaallprofileblmreposnive">
              <MyPageAboutUs data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
            </div>
            <div className="contaallprofileblmreposnive">
              <MyPageServices data={data} updateForm={updateForm} setIsUpdate={setIsUpdate} />
            </div>
            <div className="contaallprofileblmreposnive">
              <Galleryblmprofile
                setData={setData}
                data={data}
                updateForm={updateForm}
                setIsUpdate={setIsUpdate}
              />
            </div>
            <div className="contaallprofileblmreposnive">
              <Socilallinkprofile updateForm={updateForm} data={data} setIsUpdate={setIsUpdate} />

              <div className="box-border-gr d-flex justify-content-center align-items-center bg-white p-3 mt-2">
                <button className="btn btn-secondary m-2" onClick={onBack}>
                  Back
                </button>
                <button className="btn btn-success" onClick={onNext}>
                  Pay Now
                </button>
              </div>
            </div>
          </div>

          {/* Mobile Screen Design End */}


        </div>
      </section>
    </>
  );
};

export default ListBusinessMyPage;
